import {Stack} from 'shells/layout/stack/stack';

import type {InboxSidebarThreadFragment as Thread} from 'nutshell-graphql-types';

import {SidebarThreadListItem} from './sidebar-thread-list-item';
import {SidebarThreadListItemLoading} from './sidebar-thread-list-item-loading';

import styles from './inbox-sidebar-thread-list.module.css';

interface Props {
    threads: Thread[];
    numThreads: number;
    isLoading: boolean;
    selectedThreadId: string | null;
    onSelectThread: (threadId: string) => void;
}

export function InboxSidebarThreadList(props: Props) {
    const items = props.isLoading
        ? Array.from({length: props.numThreads}, (_, i) => <SidebarThreadListItemLoading key={i} />)
        : props.threads.map((thread) => (
              <SidebarThreadListItem
                  key={thread.id}
                  selected={props.selectedThreadId === thread.id}
                  onSelect={() => props.onSelectThread(thread.id)}
                  entityName={thread.bestEntity?.name ?? 'Unidentified'}
                  summary={thread.threadSummary}
                  displayMessage={thread.displayMessage?.content ?? 'No message available'}
                  messageCount={thread.messageCount}
              />
          ));

    return (
        <div className={styles['inbox-sidebar-thread-list']}>
            <Stack>{items}</Stack>
        </div>
    );
}
